import { Box, BoxProps, Fab } from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import React from "react";

const AddButton: React.FC<BoxProps> = (props) => (
    <Box position="absolute" bottom={16} right={16} {...props}>
        <Fab color="primary">
            <AddIcon />
        </Fab>
    </Box>
);

export default AddButton;
export { AddButton };
